export default __webpack_public_path__ + "static/media/logo.35baa99f.png";